import { DecisionType } from '../constants/decision';
import { ApplicationLifecycle } from '../constants/lifecycle';

const lifecycleToDecisionType: Record<string, DecisionType> = {
  [ApplicationLifecycle.PIA]: DecisionType.PIA,
  [ApplicationLifecycle.REINSTATEMENT]: DecisionType.REINSTATEMENT,
  [ApplicationLifecycle.PLAN_F]: DecisionType.PLAN_F,
  [ApplicationLifecycle.RUW]: DecisionType.FINAL,
};

export function getDecisionTypeForLifecycle(lifecycle: string): DecisionType {
  return lifecycleToDecisionType[lifecycle] ?? DecisionType.FINAL;
}
